/*
 * ITG gallery video
 * --------------------------------------------------------------------------
 * Keeps the metafield-driven MP4 hero video (rendered by
 * `itg-gallery-video.liquid` as the first slide) playing.
 *
 * Why this is needed: Dawn's global `pauseAllMedia()` pauses every <video> on
 * the page on each slide change / modal open. So when the shopper navigates
 * away from the video slide and back, the native autoplay attribute won't
 * restart it. This re-plays the video whenever its slide becomes active, and
 * forces the initial autoplay for Safari/iOS where the attribute is ignored.
 */
(function () {
  function playActiveVideo(gallery) {
    var active = gallery.querySelector(
      '[id^="GalleryViewer"] .slider__slide.is-active .itg-gallery-video'
    );
    if (!active) return;
    var promise = active.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var video = gallery.querySelector('.itg-gallery-video');
      if (!video) return;

      // Force initial autoplay (Safari/iOS sometimes ignore the attribute).
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});

      // Re-play when the video slide becomes active again. pauseAllMedia()
      // runs synchronously on click/slide change, so defer slightly.
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer) {
        viewer.addEventListener('slideChanged', function () {
          setTimeout(function () { playActiveVideo(gallery); }, 50);
        });
      }
      var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (thumbnails) {
        thumbnails.addEventListener('click', function () {
          setTimeout(function () { playActiveVideo(gallery); }, 50);
        });
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
